"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    title: _propTypes.default.string.isRequired,
    titleType: _propTypes.default.shape({
      type: _propTypes.default.string,
      color: _propTypes.default.string
    }),
    content: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.element]).isRequired,
    imgSrc: _propTypes.default.string,
    imgWidth: _propTypes.default.string,
    imgHeight: _propTypes.default.string,
    icon: _propTypes.default.string,
    iconPosition: _propTypes.default.string,
    iconColor: _propTypes.default.string,
    iconSize: _propTypes.default.string,
    contentColor: _propTypes.default.string,
    bgColor: _propTypes.default.string,
    hasBorder: _propTypes.default.bool,
    hasBoxShadow: _propTypes.default.bool,
    titleFirst: _propTypes.default.bool,
    hasTextToggle: _propTypes.default.bool,
    textLimit: _propTypes.default.number,
    translation: _propTypes.default.object,
    isMobile: _propTypes.default.bool,
    hasHeader: _propTypes.default.bool,
    tagline: _propTypes.default.string,
    isPromoApplied: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    hasTextToggle: false,
    hasBoxShadow: false,
    titleFirst: false,
    iconSize: 'titleLarge',
    iconPosition: 'left',
    imgHeight: '40px',
    imgWidth: '50px',
    dataList: [],
    isMobile: false,
    hasHeader: true,
    titleType: {
      type: 'default',
      color: ''
    }
  }
};
exports.default = _default;